<template>
  <div class="mb-4 ml-4 mr-4">
    <b-card-group deck>
    <!-- Total de Vendas -->
      <b-card class="text-center shadow-sm">
        <div class="h6 text-muted">Total de Vendas mês Atual</div>
        <div class="h4 font-weight-bold text-success">R$ {{ formatar(valorTotal) }}</div>
      </b-card>

    <!-- Meta do Mês -->
      <b-card class="text-center shadow-sm">
        <div class="h6 text-muted">Meta do Mês</div>
        <div class="h4 font-weight-bold text-primary">R$ {{ formatar(valorMeta) }}</div>
        <b-progress :value="percentualMeta" :max="100" height="10px" class="mt-2">
          <b-progress-bar :value="percentualMeta" :label="`${percentualMeta.toFixed(1)}%`" />
        </b-progress>
      </b-card>

    <!-- Ticket Médio -->
      <b-card class="text-center shadow-sm">
        <div class="h6 text-muted">Valores Vencidos</div>
        <div class="h4 font-weight-bold text-danger">R$ {{ formatar(areceberVencidos) }}</div>
      </b-card>

    <!-- Vendas Pendentes -->
      <b-card class="text-center shadow-sm">
        <div class="h6 text-muted">Quantidade Vencidos</div>
        <div class="h4 font-weight-bold text-warning">{{ vendasPendentes }} pedidos</div>
      </b-card>

    <!-- Comissão -->
      <b-card class="text-center shadow-sm">
        <div class="h6 text-muted">Comissão Estimada</div>
        <div class="h4 font-weight-bold text-info">R$ {{ formatar(valorComissao) }}</div>
      </b-card>
    </b-card-group>  
  </div>
</template>

<script>
export default {
  name: 'IndicadoresVendas',
  props: {
    valorTotal: Number,
    valorMeta: Number,
    areceberVencidos: Number,
    vendasPendentes: Number,
    valorComissao: Number
  },
  computed: {
    percentualMeta() {
      if (!this.valorMeta) return 0
      return (this.valorTotal / this.valorMeta) * 100
    }
  },
  methods: {
    formatar(valor) {
      return valor?.toLocaleString('pt-BR', { minimumFractionDigits: 2 }) ?? '0,00'
    }
  }
}
</script>



// WEBPACK FOOTER //
// src/views/dashboard/IndicadoresVendas.vue